import PropTypes        from 'prop-types';
import React            from 'react';

import * as S                from './current-plan-bm.module.scss';
import { Price }             from '../../../common/product/price';
import { useGlobalCtx }      from '../../../../context/ctx-hook';
import * as BillSelectors from '../../../../context/selectors/bill-selectors';
import { splitQuota }        from '../../../../helpers/pure-functions';
import { getProductLogo    } from '../../../../context/selectors/product-selectors';

const CurrentPlanBm = ({handleChangePlan, sku, name, uriName, ctaText, quota, isPromo}) => {
  const {state}    = useGlobalCtx();
  const QKN_SUB = BillSelectors.getQknSubscription(state, state?.country);
  const {tierName} = BillSelectors.getQknSubscriptionObj(QKN_SUB, state?.country);

  let {billpay = '', checkpay = ''} = React.useMemo(
    () => splitQuota(quota),
    []
  );

  return (
    <div>
      <div className={S.label}>Your current plan</div>
      <article className={`${S.currentPlan} ${uriName}`} data-testid={`PLAN_${uriName.toUpperCase()}`}>
        <div className={S.leftSide}>
          <div className={S.header}>
            <img src={getProductLogo('billmanager')} alt="square product logo" />
            <div className={S.prodText}>
              <div className={S.name}>{name}</div>
              <p className={`${S.quota} ${S.stackedP}`}>Check Pay - {checkpay} per month </p>
              <p className={`${S.quota} ${S.stackedP}`}>Quick Pay - {billpay} per month </p>
              {!sku && !isPromo && <p className={S.benefit}>Included with Quicken {tierName}</p>}
            </div>

          </div>

        </div>

        <div className={S.rightSide}>

        </div>

        {sku && (<Price
          className={S.currentPrice}
          renewalFrequency="P1M"
          sku={sku}
        />)}

        {/* Think expiry is meant to be loaded here but we have no sub data? Probably just need to re-do this component */}
        {/* <Expiry /> */}
      </article>
    </div>
  );
};

CurrentPlanBm.displayName = 'CurrentPlanBm';
CurrentPlanBm.propTypes   = {
  sku:     PropTypes.string,
  name:    PropTypes.string.isRequired,
  uriName: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  quota:   PropTypes.string.isRequired,
  isPromo: PropTypes.bool,

  handleChangePlan: PropTypes.func.isRequired
};

export { CurrentPlanBm };
